import LMap from './src/main'

LMap.install = function(Vue) {
  Vue.component(LMap.name, LMap)
}

export default LMap
